
export const accounts = [
    {
        UserName: 'netcovip',
        Password: 'netcovip@123',
    },
    {
        UserName: 'netcotimekeeping',
        Password: 'netco@123',
    },
    {
        UserName: 'deployment',
        Password: 'deployment@netco123',
    },
]